import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ProTable, Link, DateDisplay } from 'components/layout';
import { stringSorter } from 'utils';
import DeleteProposalRevision from './DeleteProposalRevision';
import { ENUM_APPLICATION_STATUS } from 'constants/form';
import { useHasScopeTypeInProject } from 'hooks';

const proposalRevisionsUrl = ({ projectId, id }) =>
  `/projects/${projectId}/proposal-revisions/${id}`;

const ProposalRevisionsTable = ({ proposalRevisions, ...props }) => {
  const { projectId } = useParams();
  const { hasScopeType } = useHasScopeTypeInProject('WRITE_PROPOSAL_REVISION');
  const columns = [
    {
      title: 'Application Date',
      dataIndex: 'date',
      sorter: (a, b) => a.date - b.date,
      render: (_, item) => (
        <Link to={proposalRevisionsUrl({ projectId, id: item.id })}>
          <DateDisplay date={item.date} />
        </Link>
      ),
    },
    {
      title: 'Justification',
      dataIndex: 'justification',
      ellipsis: true,
      sorter: (a, b) => stringSorter(a.justification, b.justification),
      render: (_, item) => (
        <Link to={proposalRevisionsUrl({ projectId, id: item.id })}>{_}</Link>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      valueEnum: ENUM_APPLICATION_STATUS,
      sorter: (a, b) => stringSorter(a.status, b.status),
      filters: true,
      onFilter: true,
      render: (_, item) => (
        <Link to={proposalRevisionsUrl({ projectId, id: item.id })}>{_}</Link>
      ),
    },
    hasScopeType && {
      title: 'Actions',
      render: (_, item) => <DeleteProposalRevision id={item.id} />,
    },
  ];

  return (
    <ProTable
      columns={columns}
      dataSource={proposalRevisions}
      pagination={false}
      search={false}
      toolBarRender={false}
      rowKey={({ id }) => id}
      {...props}
    />
  );
};

ProposalRevisionsTable.defaultProps = {
  proposalRevisions: [],
};

ProposalRevisionsTable.propTypes = {
  proposalRevisions: PropTypes.array.isRequired,
};

export default ProposalRevisionsTable;
